import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Apps from '../views/apps/Apps.vue'
import Transsion from '../views/Transsion.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: '/',
        name: 'app',
        component: Apps,
      },
      {
        path: '/transsion',
        name: 'Transsion',
        component: Transsion,
      },
      {
        path: '/app_list',
        name: 'AppList',
        component: () => import('../views/AppList.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/more',
    name: 'More',
    component: () => import('../views/More.vue')
  },
  {
    path: '/apk-break',
    name: 'ApkBreak',
    component: () => import('../views/ApkBreak.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
